export const getCookieByKey = (cookieKey: string) => {
  const cookies: Record<string, string> = {};

  document.cookie.split(';').forEach((cookie) => {
    const [key, value] = cookie.split('=');
    cookies[key.trim()] = value;
  });

  return cookies[cookieKey];
};

export const setCookie = (name: string, value: string) => {
  document.cookie = `${name} = ${value};path=/`;
};
